import Icon from '../components/Icon';

const DifficultyHard = Icon(
  'difficulty-hard',
  <>
    <path d="M9.402 6c1.155-2 4.041-2 5.196 0l5.196 9c1.155 2-.288 4.5-2.598 4.5H6.804c-2.31 0-3.753-2.5-2.598-4.5z" />
  </>
);

export default DifficultyHard;
